// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1820":"865f0ee7130e041c","8235":"513fee23e4038a10","9338":"e9c8ea1d673e13cd"}[chunkId] + ".css";
};